export default __webpack_public_path__ + "vendor/stylesheets/themify-icons.css";